"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AcknowledgementCard = require('../model/procedure/acknowledgement-card');

var AttendanceCard = require('../model/procedure/attendance-card');

var Card = require('../model/procedure/card');

var CheckboxCard = require('../model/procedure/checkbox-card');

var ChemicalCard = require('../model/procedure/chemical-card');

var ChemicalBandCard = require('../model/procedure/chemical-band-card');

var ConditionCard = require('../model/procedure/condition-card');

var EquipmentCard = require('../model/procedure/equipment-card');

var InspectCard = require('../model/procedure/inspect-card');

var InventoryCard = require('../model/procedure/inventory-card');

var LocationCard = require('../model/procedure/location-card');

var LotoElectricalCard = require('../model/procedure/loto-electrical-card');

var ValueUnitCard = require('../model/procedure/value-unit-card');

var QuestionCard = require('../model/procedure/question-card');

var ReferenceCard = require('../model/procedure/reference-card');

var SelectCard = require('../model/procedure/select-card');

var TextCard = require('../model/procedure/text-card');

var TableCard = require('../model/procedure/table-card');

var BuaCard = require('../model/procedure/bua-card');

var BiosafetyCard = require('../model/procedure/biosafety-card');

var BuaAttendanceCard = require('../model/procedure/bua-attendance-card');

module.exports.createCardFactory = function (type, card) {
  switch (type) {
    case 'ACKNOWLEDGEMENT':
      return new AcknowledgementCard(card);

    case 'ATTENDANCE':
      return new AttendanceCard(card);

    case 'BIOSAFETY':
      return new BiosafetyCard(card);

    case 'BUA':
      return new BuaCard(card);

    case 'BUA_ATTENDANCE':
      return new BuaAttendanceCard(card);

    case 'CHECKBOX':
      return new CheckboxCard(card);

    case 'CHEMICAL':
      return new ChemicalCard(card);

    case 'CHEMICAL_BAND':
      return new ChemicalBandCard(card);

    case 'CONDITION':
      return new ConditionCard(card);

    case 'EQUIPMENT':
      return new EquipmentCard(card);

    case 'INSPECT':
      return new InspectCard(card);

    case 'INVENTORY':
      return new InventoryCard(card);

    case 'LOCATION':
      return new LocationCard(card);

    case 'LOTO_ELECTRICAL':
      return new LotoElectricalCard(card);

    case 'QUESTION':
      return new QuestionCard(card);

    case 'REFERENCE':
      return new ReferenceCard(card);

    case 'SELECT':
      return new SelectCard(card);

    case 'TEXT':
      return new TextCard(card);

    case 'VALUE_UNIT':
      return new ValueUnitCard(card);

    case 'TABLE':
      return new TableCard(card);

    default:
      return _objectSpread(_objectSpread({}, new Card(card)), {}, {
        details: {}
      });
  }
};